import React from 'react';
import './OrderTable.css';
import {Link} from 'react-router-dom';
import Loading from '../../Components/Loading/Loading';

const OrderTable =(props)=>{
    const handle_state=[['draft','ongoing','ongoing','ongoing','ongoing','ongoing','ongoing','delivered','failed','canceled'],
    ['failed','failed','failed','failed','failed','failed','failed','failed','ongoing','canceled'],
    ['trash','trash','trash','trash','trash','trash','trash','trash','trash','canceled'],
    ['draft','ongoing','ongoing','ongoing','ongoing','ongoing','ongoing','delivered','failed','canceled'],
    ['draft','ongoing','ongoing','ongoing','ongoing','ongoing','ongoing','delivered','failed','canceled'],
    ['draft','ongoing','ongoing','ongoing','ongoing','ongoing','ongoing','delivered','failed','canceled']
]
const handle_stateAR=[['مسوده','في الطريق','في الطريق','في الطريق','في الطريق','في الطريق','في الطريق','تم التوصيل','فشلت','تم الالغاء'],
['فشلت','فشلت','فشلت','فشلت','فشلت','فشلت','فشلت','فشلت','في الطريق','تم الالغاء'],
['مهمل','مهمل','مهمل','مهمل','مهمل','مهمل','مهمل','مهمل','مهمل','تم الالغاء'],
['مسوده','في الطريق','في الطريق','في الطريق','في الطريق','في الطريق','في الطريق','تم التوصيل','فشلت','تم الالغاء'],
['مسوده','في الطريق','في الطريق','في الطريق','في الطريق','في الطريق','في الطريق','تم التوصيل','فشلت','تم الالغاء'],
['مسوده','في الطريق','في الطريق','في الطريق','في الطريق','في الطريق','في الطريق','تم التوصيل','فشلت','تم الالغاء']

]
        return(
                <div className="col-md-4 px-2 py-3 OrderTable">

                                <div className="tableDetails border shadow mx-auto">
                                <p className="col-6 m-3 p-0 fontsize4">جميع الطلابات</p>

                                    <div className="thead-light fontsize12 text-muted">
                                        <div className="headertable p-3 border">
                                            <p className="m-0">مرتبة حسب رقم الطلب</p>
                                        </div>
                                    </div>
                                   
                                        <div className="fontsize12">
                                        {
                                            
                                        }
                                        {
                                            (props.state.isLoading?<Loading/>:
                                                props.state.dataorders.map((x, i) => (
                                                    <div className={"p-3 border-bottom "+(props.state.ordernumber  ===x.ordernumber ? 'active' : '')}  key={i}>
                                                    <div className="row">
                                                        <div className="col-7">
                                                            <Link to={"/AR/OrderDetail/"+x.ordernumber}  onClick={() =>  props.getorderid(x.ordernumber)}><p>{x.reciver.name} <br /> {x.ordernumber}</p></Link>
                                                        </div>
                                                        <div className="col-5 p-1">
                                                            <span className={"badge-pill "+handle_state[x.failedstatus][x.status]}>{handle_stateAR[x.failedstatus][x.status]}</span>
                                                        </div>
                                                    </div>
                                                </div>
    
                                                )))
                                        }
                                    </div>
                                </div>
                            </div> 
                           

        )
    }

export default OrderTable;